/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import React from 'react';
import { Modal, Typography } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import { useIntl } from 'react-intl';
import { ModalTitle } from '~components/_common/ModalTitle/ModalTitle';
import settingImg from '~src/assets/help-imgs/setting-file.png';
import removingImg from '~src/assets/help-imgs/removing-file.png';

export type PrimaryPreviewInfoModalProps = Partial<ModalProps>;

export const PrimaryPreviewInfoModal: React.FC<PrimaryPreviewInfoModalProps> = ({
  onCancel,
  ...modalProps
}) => {
  const intl = useIntl();

  return (
    <Modal
      title={
        <ModalTitle
          text={intl.formatMessage({ id: 'primary-info-title' })}
          icon={['far', 'info-circle']}
        />
      }
      width={560}
      centered
      footer={null}
      onCancel={onCancel}
      {...modalProps}>
      <Typography.Paragraph strong>
        {intl.formatMessage({ id: 'primary-info-title' })}
      </Typography.Paragraph>

      <Typography.Paragraph>
        <strong>
          {intl.formatMessage({ id: 'primary-info-setting-title' })}
        </strong>
        <br />
        {intl.formatMessage({ id: 'primary-info-setting-body' })}
      </Typography.Paragraph>

      <img
        src={settingImg}
        alt={intl.formatMessage({
          id: 'primary-svf-file-set',
        })}
      />

      <Typography.Paragraph>
        <strong>
          {intl.formatMessage({ id: 'primary-info-removing-title' })}
        </strong>
        <br />
        {intl.formatMessage({ id: 'primary-info-removing-body' })}
      </Typography.Paragraph>

      <img
        src={removingImg}
        alt={intl.formatMessage({
          id: 'primary-svf-file-remove',
        })}
        css={imgStyle}
      />

      <Typography.Paragraph>
        <strong>{intl.formatMessage({ id: 'primary-info-note-title' })}</strong>
        <br />
        {intl.formatMessage({ id: 'primary-info-note-line1' })}
        <br />
        {intl.formatMessage({ id: 'primary-info-note-line2' })}
      </Typography.Paragraph>
    </Modal>
  );
};

const imgStyle = css`
  display: block;
  margin: 20px auto;
  max-width: 260px;
  border-radius: 6px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
`;
